import { FC } from 'react';
import classNames from 'classnames';
import './progressBar.scss';

interface IProgressBar {
  value: number;
  theme: 'yellow';
}

const ProgressBar: FC<IProgressBar> = ({ value, theme }) => {
  return <div className={classNames('progress-bar', [theme])} style={{ width: `${value}%` }} />;
};

export default ProgressBar;
